// extracted by mini-css-extract-plugin
export default {"Barcode":"Barcode_Barcode__xzJFH","CountDown":"Barcode_CountDown__iuarT","CountDownText":"Barcode_CountDownText__tcXDF"};